
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AutolockSessionStateService {
  private detectionKey = '';
  private activeTabsKey = '';
  private readonly tabIdKey = 'tabId';

  private tabId: string;

  private heartbeatInterval: any; //  added
  private readonly heartbeatMs = 5000; //  added
  private readonly staleMs = 15000; //  added (15 seconds)
  // Track last user activity time
  lastActivityKey = "";
  idleMs = 20 * 60 * 1000; // 20 mins

  constructor() { }

  setKeys(detectionKey: string, activeTabsKey: string): void {
    this.detectionKey = detectionKey;
    this.activeTabsKey = activeTabsKey;
    this.lastActivityKey = 'LAST_ACTIVITY' + this.activeTabsKey;

    this.cleanupEmptySessionKeys();
    this.tabId = this.getOrCreateTabId();

    this.cleanupStaleTabs();       //  added
    this.registerTab();
    this.startHeartbeat();         //  added

    // Track user activity for idle timeout
    this.trackUserActivity();

    window.addEventListener('beforeunload', () => this.unregisterTab());
  }

  private getOrCreateTabId(): string {
    let existingId = sessionStorage.getItem(this.tabIdKey);
    if (existingId) return existingId;

    const newId = Date.now().toString() + Math.random().toString(36).substring(2);
    sessionStorage.setItem(this.tabIdKey, newId);
    return newId;
  }

  //  Store tabs as map: { tabId: timestamp }
  private getActiveTabsMap(): any {
    return JSON.parse(localStorage.getItem(this.activeTabsKey) || '{}');
  }

  private setActiveTabsMap(map: any): void {
    localStorage.setItem(this.activeTabsKey, JSON.stringify(map));
  }

  //  Cleanup expired or stale tabs
  private cleanupStaleTabs(): void {
    const tabs = this.getActiveTabsMap();
    const now = Date.now();
    const sessionKey = this.detectionKey;

    // if (!sessionStorage.getItem(sessionKey)) {
    const cleaned = Object.entries(tabs)
      .filter(([, data]: any) => now - data.lastSeen < this.staleMs)
      .reduce((acc, [id, data]) => {
        acc[id] = data;
        return acc;
      }, {});

    this.setActiveTabsMap(cleaned);
    // }
  }

  private registerTab(): void {
    const tabs = this.getActiveTabsMap();
    tabs[this.tabId] = { lastSeen: Date.now() };
    this.setActiveTabsMap(tabs);
  }

  // Heartbeat to refresh tab timestamp
  private startHeartbeat(): void {
    this.heartbeatInterval = setInterval(() => {
      const tabs = this.getActiveTabsMap();
      tabs[this.tabId] = { lastSeen: Date.now() };
      this.setActiveTabsMap(tabs);
    }, this.heartbeatMs);
  }

  private unregisterTab(): void {
    const tabs = this.getActiveTabsMap();
    delete tabs[this.tabId];
    this.setActiveTabsMap(tabs);

    if (Object.keys(tabs).length === 0) {
      localStorage.removeItem(this.detectionKey);
    }
  }

  //  Convert map → array of IDs only
  private getActiveTabs(): string[] {
    return Object.keys(this.getActiveTabsMap());
  }

  // isFirstVisit(): boolean {
  //   const detectionFlag = localStorage.getItem(this.detectionKey);
  //   const tabs = this.getActiveTabs();
  //   const sessionKey = this.detectionKey;

  //   if (!sessionStorage.getItem(sessionKey)) {
  //     if (!detectionFlag && tabs.length === 1 && tabs[0] === this.tabId) {
  //       return true;
  //     }
  //   }
  //   return false;
  // }

  isFirstVisit() {
    const detectionFlag = localStorage.getItem(this.detectionKey);
    const tabs = Object.keys(this.getActiveTabsMap());

    // Check idle timeout
    const last = parseInt(localStorage.getItem(this.lastActivityKey) || "0");
    const isIdleExpired = Date.now() - last > this.idleMs;

    // If idle expired → reset detection flag
    if (isIdleExpired) {
      localStorage.removeItem(this.detectionKey);
    }

    // First browser session OR idle expired
    if (!sessionStorage.getItem(this.detectionKey)) {
      return (!detectionFlag || isIdleExpired) && tabs.length === 1 && tabs[0] === this.tabId;
    }

    return false;
  }
  markVisited(): void {
    localStorage.setItem(this.detectionKey, 'true');
    sessionStorage.setItem(this.detectionKey, 'true');
  }
  trackUserActivity() {
    const update = () => {
      localStorage.setItem(this.lastActivityKey, Date.now().toString());
    };

    window.addEventListener("mousemove", update);
    window.addEventListener("keydown", update);
    window.addEventListener("click", update);
    window.addEventListener("scroll", update);

    update();
  }


  cleanupEmptySessionKeys() {
    const keysToDelete = [];

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key) continue;

      if (key.startsWith("pt_") || key.startsWith("opt_") || key.startsWith("Apt_") ||
        key.startsWith("rd_") || key.startsWith("ord_") || key.startsWith("Ard_") ||
        key.startsWith("di_") || key.startsWith("odi_") || key.startsWith("Adi_") ||
        key.startsWith("edi_") || key.startsWith("oedi_") || key.startsWith("Aedi_")) {
        const value = localStorage.getItem(key);

        if (!value || value.trim() === "{}") {
          keysToDelete.push(key);
          const lastActivityKey = `LAST_ACTIVITY${key}`;
          keysToDelete.push(lastActivityKey);
        }
      }
    }

    keysToDelete.forEach(k => localStorage.removeItem(k));
  }
}
